var utils = require('lib/utils');
import ef from 'ef/ef';
var LocaleService = require('services/locale-service');

// Application-specific Handlebars helpers
// -------------------------------------------
// TODO: revisit this helper - conflicts with resources.url property
// Get Chaplin-declared named routes. {{#url "like" "105"}}{{/url}}.
//Handlebars.registerHelper('url', function(routeName) {
//  var params = [].slice.call(arguments, 1);
//  var options = params.pop();
//  return utils.reverse(routeName, params);
//});

var HandlebarsExtensions = {
  _blocks: [],
  helpers: {
    partial: function(name, ctx, options) {
      var ps = Handlebars.partials;
      if(typeof ps[name] !== 'function')
        ps[name] = Handlebars.compile(ps[name]);
      if(options.hash) {
        ctx = $.extend({}, ctx, options.hash);
      }
      return new Handlebars.SafeString(ps[name](ctx, options));
    },
    block: function(name) {
      var blocks = HandlebarsExtensions._blocks;
      var content= blocks && blocks[name];
      if(content) {
        content = new Handlebars.SafeString(content.join('\n'));
      } else {
        content = null;
      }
      return content;
    },
    content_for: function(name, options) {
      var blocks = HandlebarsExtensions._blocks;
      var block = blocks[name] || (blocks[name] = []);

      block.push(options.fn(this));
    },
    /**
     ** Warning! **
     * This exposes an XSS vulnerability that was fixed in this PR
     *   https://github.com/EverFi/ContentPartnerAPI/pull/140
     * SafeString will not HTML encode the result and as a consequence will execute script in the translation files
     *
     * Several of the views inject HTML tags to style things or add other content, so this was reverted
     *
     * To mitigate this one of two things can be done:
     *    * Don't call SafeString and just return the result of LocalService.t(key). Handlebars will HTML encode the result.
     *    * Handle the HTML encoding yourself and use SafeString since the result is already encoded
     *
    **/
    t: function(key) {
      var result = LocaleService.t(key);
      if(ef.forge_mode) {
        let gotResult = (result === key ? 'no' : 'yes');
        return new Handlebars.SafeString("<span data-forgeaction='editlocale' data-key='"+key+"' data-translated='"+gotResult+"'>"+result+'</span>');
      }
      return new Handlebars.SafeString(result);
    },
    pt: function(key) {
      // translates 'plain text only' fields (avoids forge-mode)
      var result = LocaleService.t(key);
      return new Handlebars.SafeString(result);
    },
    f: function(action, key, cid, forge_path, label) {
      // returns a forge-mode 'action' tag for a field 'key' that is tied to its parent 'block' CID code and objpath
      if(ef.forge_mode) {
        var result = LocaleService.t(key);
        let gotResult = (result === key ? 'no' : 'yes');
        return new Handlebars.SafeString("<span data-forgeaction='"+action+"' data-key='"+key+"' data-sdkcid='"+cid+"' data-objpath='"+forge_path+"' data-label='"+label+"' data-translated='"+gotResult+"'></span>");
      }
      return null;
    },
    m: function(content) {
      return new Handlebars.SafeString(marked(content));
    },
    tm: function(key) {
      var result = marked(LocaleService.t(key));
      return new Handlebars.SafeString(result);
    },
    indexToCount: function(i) {
      return i + 1;
    },
    assetPath: function(path) {
      var fullPath = utils.coursePath(path);
      return new Handlebars.SafeString(fullPath);
    },
    times: function(n, block) {
      return [...new Array(n).keys()].reduce((result, index) => {
        var data;
        if(block.data) {
            data = Handlebars.createFrame(block.data);
        }
        if(data) {
            data.index = index;
        }
        return result += block.fn(index, {data:data});
      }, '');
    },
    style: function(value) {
      return Object.keys(value).map(e => `${e}: ${value[e]}`).join(';');
    },
    yamlize: function(value, indent) {
      let yamlized = YAML.stringify(value, Infinity);
      return indent === undefined ? yamlized : yamlized.replace(/\n/g, '\n' + ' '.repeat(indent));
    },
    jsonize: function(value) {
      return JSON.stringify(value);
    },
    equal: function(first, second) {
      return first === second;
    },
    subIf: function(v1, success, fail, operator, v2) {
      const conditions = {
        '==': (v1, v2) => v1 == v2,
        '===': (v1, v2) => v1 === v2,
        '!=': (v1, v2) => v1 != v2,
        '!==': (v1, v2) => v1 !== v2,
        '<': (v1, v2) => v1 < v2,
        '<=' : (v1, v2) => v1 <= v2,
        '>' : (v1, v2) => v1 > v2,
        '>=' : (v1, v2) => v1 >= v2,
        '&&' : (v1, v2) => v1 && v2,
        '||' : (v1, v2) => v1 || v2,
        undefined : () => false
      };
      const isOperatorString = typeof operator === 'string' || operator instanceof String;
      return isOperatorString ? (conditions[operator](v1,v2) ? success : fail) : (v1 ? success : fail);
    },
    compare: function(v1, operator, v2, options) {
      const conditions = {
        '==': (v1, v2) => v1 == v2,
        '===': (v1, v2) => v1 === v2,
        '!=': (v1, v2) => v1 != v2,
        '!==': (v1, v2) => v1 !== v2,
        '<': (v1, v2) => v1 < v2,
        '<=' : (v1, v2) => v1 <= v2,
        '>' : (v1, v2) => v1 > v2,
        '>=' : (v1, v2) => v1 >= v2,
        '&&' : (v1, v2) => v1 && v2,
        '||' : (v1, v2) => v1 || v2,
        undefined : () => options.inverse(this)
      };
      return conditions[operator](v1,v2) ? options.fn(this) : options.inverse(this);
    },
    defined: function() {
      return !Array.from(arguments).some((argument) => {
        return argument === undefined;
      });
    },
        /**
     * Concats N items together
     * Usage: <div>{{ (concat 'one ' 'two ' 'three ', 'N') }}</div> => <div>one two three N</div>
     */
    concat: function(...args) {
      // slice to throw away last object since it contains handlebars configuration
      return args.reduce(function(result, arg) {
        return typeof arg === 'string' ? result.concat(arg) : result;
      }, '');
    }
  },
  finish_blocks: function(template) {
    //TODO: review this code and see if it should be removed
    for(var b in HandlebarsExtensions._blocks) {
      var content = HandlebarsExtensions._blocks[b].join('\n');
      template = template.replace('{{block:' + b + '}}', content);
    }
    HandlebarsExtensions._blocks = [];
    return template;
  }
};

for(var helper in HandlebarsExtensions.helpers) {
  if(HandlebarsExtensions.helpers.hasOwnProperty(helper) && typeof(HandlebarsExtensions.helpers[helper]) === 'function') {
    Handlebars.registerHelper(helper, HandlebarsExtensions.helpers[helper]);
  }
}
